import { render, staticRenderFns } from "./PieConsultationsISTTypeDouleurPsychique.vue?vue&type=template&id=607e97ea&"
import script from "./PieConsultationsISTTypeDouleurPsychique.vue?vue&type=script&lang=ts&"
export * from "./PieConsultationsISTTypeDouleurPsychique.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports